/**
 * @generated SignedSource<<a00cded80ed101fa6b41f1dac2a5b203>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightProvider = "KIWI" | "WAAVO";
export type FlightsProvider = "KIWI" | "WAAVO";
export type SmtpType = "NONE" | "SSL" | "TLS";
export type UpdateSettingsInput = {
  abandonedCheckoutTimeout?: number | null;
  adminEmailErrors?: string | null;
  adminEmailNewsSubscribers?: string | null;
  adminEmailOrders?: string | null;
  advancePayment?: number | null;
  autosaveDelay?: number | null;
  cancelOrdersAfterMinutes?: number | null;
  debugMode?: boolean | null;
  defaultTransferPrice?: number | null;
  descriptionTitle?: string | null;
  durationRanges?: ReadonlyArray<IntRangeInput> | null;
  etg?: EtgSettingsInput | null;
  facebookAppId?: string | null;
  facebookSettings?: FacebookSettingsInput | null;
  flightBookingEnabled?: boolean | null;
  flightsApiLimit?: number | null;
  flightsProvider?: FlightsProvider | null;
  flightsProviderSettings?: ReadonlyArray<FlightsProviderSettingsInput> | null;
  flightsUpdaterEnabled?: boolean | null;
  google?: GoogleSettingsInput | null;
  inactiveUpdaterWarningThreshold?: number | null;
  infantTripPrice?: number | null;
  keepFlightPriceHistoryDays?: number | null;
  notesTitle?: string | null;
  orderCleanupAge?: number | null;
  paysera?: PayseraSettingsInput | null;
  priceChangeTreshold?: number | null;
  priceCheckerLimit?: number | null;
  profiler?: boolean | null;
  revalidateStaticContent?: number | null;
  schemaProviderDetails?: SchemaProviderDetailsInput | null;
  scoro?: ScoroSettingsInput | null;
  seoHomeMetaDescription?: string | null;
  seoHomeTitle?: string | null;
  smtpEmail?: string | null;
  smtpName?: string | null;
  smtpPassword?: string | null;
  smtpPort?: number | null;
  smtpServer?: string | null;
  smtpType?: SmtpType | null;
  smtpUser?: string | null;
  standardMarkupAdult?: number | null;
  standardMarkupChild?: number | null;
  titleSuffix?: string | null;
  tripsH1?: string | null;
  tripsMetaDescription?: string | null;
  tripsMetaTitle?: string | null;
  updateFlightsPerMinute?: number | null;
};
export type IntRangeInput = {
  end: number;
  start: number;
};
export type SchemaProviderDetailsInput = {
  address?: string | null;
  city?: string | null;
  country?: string | null;
  image?: string | null;
  logo?: string | null;
  name?: string | null;
  phone?: string | null;
  postcode?: string | null;
  pricerange?: string | null;
};
export type FlightsProviderSettingsInput = {
  apiKey?: string | null;
  baseUri?: string | null;
  flightsProvider: FlightProvider;
  searchParams?: ReadonlyArray<KeyValuePairInput> | null;
  testMode?: boolean | null;
};
export type KeyValuePairInput = {
  key: string;
  value?: string | null;
};
export type FacebookSettingsInput = {
  accessToken?: string | null;
  loginAppId?: string | null;
  loginAppSecret?: string | null;
  pixelId?: string | null;
  testCode?: string | null;
};
export type EtgSettingsInput = {
  fullLogContext?: boolean | null;
  incrementalBatchSize?: number | null;
  incrementalImport?: boolean | null;
  key?: string | null;
  keyId?: string | null;
  maxRateUpdateFrequency?: number | null;
  rateUpdatesEnabled?: boolean | null;
};
export type PayseraSettingsInput = {
  acceptUrl?: string | null;
  callbackUrl?: string | null;
  cancelUrl?: string | null;
  currency?: string | null;
  lang?: string | null;
  password?: string | null;
  paytext?: string | null;
  projectId?: string | null;
};
export type GoogleSettingsInput = {
  analyticsId?: string | null;
  apiKey?: string | null;
  loginClientId?: string | null;
  loginClientSecret?: string | null;
};
export type ScoroSettingsInput = {
  apiKey?: string | null;
  apiUrl?: string | null;
  ownerId?: number | null;
};
export type EtgSettingsMutation$variables = {
  input: UpdateSettingsInput;
};
export type EtgSettingsMutation$data = {
  readonly updateSettings: {
    readonly " $fragmentSpreads": FragmentRefs<"EtgSettings_settings">;
  };
};
export type EtgSettingsMutation = {
  response: EtgSettingsMutation$data;
  variables: EtgSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EtgSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Settings",
        "kind": "LinkedField",
        "name": "updateSettings",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EtgSettings_settings"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EtgSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Settings",
        "kind": "LinkedField",
        "name": "updateSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EtgSettings",
            "kind": "LinkedField",
            "name": "etg",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "keyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "incrementalImport",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "incrementalBatchSize",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullLogContext",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rateUpdatesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxRateUpdateFrequency",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b647b0c957d19d61d4a16139f8ecd6f1",
    "id": null,
    "metadata": {},
    "name": "EtgSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation EtgSettingsMutation(\n  $input: UpdateSettingsInput!\n) {\n  updateSettings(input: $input) {\n    ...EtgSettings_settings\n  }\n}\n\nfragment EtgSettings_settings on Settings {\n  etg {\n    keyId\n    key\n    incrementalImport\n    incrementalBatchSize\n    fullLogContext\n    rateUpdatesEnabled\n    maxRateUpdateFrequency\n  }\n}\n"
  }
};
})();

(node as any).hash = "d39edd7ceb98ffbae712b2bb0e8e36c0";

export default node;
